import { Button, Card, Flex, Typography } from 'antd';
import { BrandMark } from '@/components/BrandMark';
import { useSessionStore } from '@/stores/session-store';
import { ChangePasswordForm } from './ChangePasswordForm';

/** Bắt đổi mật khẩu lần đầu / sau khi Giám đốc đặt lại — chưa đổi thì chưa vào được hệ thống. */
export function ForcedPasswordChange() {
  const reload = useSessionStore((state) => state.reload);
  const logout = useSessionStore((state) => state.logout);

  return (
    <Flex align="center" justify="center" style={{ minHeight: '100dvh', padding: 24 }}>
      <Card style={{ width: 380, maxWidth: '100%' }} styles={{ body: { padding: '32px 28px' } }}>
        <Flex align="center" gap={10} style={{ marginBottom: 16 }}>
          <BrandMark />
          <Typography.Text strong>Đặt mật khẩu riêng</Typography.Text>
        </Flex>
        <Typography.Paragraph type="secondary">
          Đây là lần đầu bạn đăng nhập bằng mật khẩu tạm. Hãy đặt mật khẩu riêng trước khi vào.
        </Typography.Paragraph>
        <ChangePasswordForm
          currentPasswordLabel="Mật khẩu tạm vừa dùng"
          submitLabel="Đặt mật khẩu & vào hệ thống"
          onChanged={reload}
        />
        <Button type="link" block onClick={() => void logout()} style={{ marginTop: 8 }}>
          Đăng xuất
        </Button>
      </Card>
    </Flex>
  );
}
